import { create } from 'zustand'
import { FeatureType } from '@/domain/settings/settingTypes'

interface StoreState {
  feature?: FeatureType
}

interface StoreFunctions {
  setFeature: (feature: FeatureType) => void
  resetValidationsByFeatureStore: VoidFunction
}

export type Store = StoreState & StoreFunctions

const initialState: StoreState = {
  feature: undefined,
}

export const useValidationsByFeatureStore = create<Store>()((set) => ({
  ...initialState,
  setFeature: (feature) => set({ feature }),
  resetValidationsByFeatureStore: () => set({ ...initialState }),
}))
